export const validateEmail = (email: string, message = "") => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email && email.match(emailRegex)) {
    return true;
  } else return message;
};
export const validatePostalCode = (value: string, message = "") => {
  if (!value || value.length > 10) {
    return message;
  }
  return true;
};